export default __webpack_public_path__ + "static/media/product-18 (1).9fbad356.jpg";